/* eslint-disable */
import createIcon from '../createIcon';

const IconCloseCircleFilled = createIcon({
  name: 'icon-close-circle-filled',
  content: '<path d="M667.904 704.32L508.992 546.56 351.104 705.472l-45.376-45.056L463.552 501.44 304.64 343.488l45.12-45.376 158.912 157.824L666.56 297.088 712 342.144 553.984 501.12 712.96 659.008l-45.12 45.44zM510.528 64a448 448 0 102.944 896 448 448 0 00-2.944-896z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});
export default IconCloseCircleFilled;
